module.exports = __webpack_public_path__ + "iPad_Pro_icon.svg?58020c63efa4181d369d320d43201c5a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPad_Pro_icon.svg
// module id = 221
// module chunks = 0